import React, { Component } from 'react';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import AboutUs from '../../components/AboutUs';
import IconBox from '../../components/IconBox';
import TabBox from './../../components/TabBox';
import TestimonialSlider from '../../components/TestimonialSlider';
import FaqEvent from '../../components/FaqEvent';
import HomeBlog from '../../components/HomeBlog';
import Groupsdetails from '../../components/Groupsdetails';
import Footer from '../../components/Footer';
import { Styles } from "./styles/groups";

class Groups extends Component {
    render() {
        return (
            <Styles>
                {/* Main Wrapper */}
                <div className="main-wrapper group-page">

                    {/* Header 2 */}
                    <HeaderTwo />

                    {/* Breadcroumb */}
                    <BreadcrumbBox title="Group of Schools" />

                    {/* About Area */}
                    
                    < Groupsdetails />
                    {/* Icon Box Area */}
                    {/* <IconBox /> */}

                    {/* Tab Section */}
                    {/* <TabBox /> */}

                    {/* Testimonial Slider */}
                    {/* <TestimonialSlider /> */}

                    {/* Faq & Event Area */}
                    {/* <FaqEvent /> */}

                    {/* Footer 2 */}
                    <Footer />

                </div>
            </Styles>
        )
    }
}

export default Groups